import { Component } from 'react';
import { connect } from 'react-redux';
import { getCurrentUserLocale, getLocaleNumberSample, getCurrentUserLanguage } from '../selectors/AttributesSelector';
import { getFetchAttributesRequestStatus } from '../selectors/RequestStatusSelector';
import { stageChange, clearChange } from '../actions/StagingActions';
import { LANGUAGE, LOCALE } from '../constants/StagingDataKeys';
import LocaleEditor from '../components/LocaleEditor';
import { anyRequestsFailed, allFinished } from '../utils/requestUtils';
import { getIsUngatedBetaLanguages } from '../selectors/LocaleSelector';
import { MultiColumn, MultiColumnGroup, MultiColumnItem } from 'foundations-components/transitional/components/MultiColumn';
import { jsx as _jsx } from "react/jsx-runtime";
class LocaleContainer extends Component {
  constructor(props) {
    super(props);
    this.handleLocaleChanged = this.handleLocaleChanged.bind(this);
  }
  handleLocaleChanged(locale) {
    if (locale !== this.props.locale) {
      this.props.stageChange(LOCALE, locale);
    } else {
      this.props.clearChange(LOCALE);
    }
  }
  render() {
    const {
      language,
      locale,
      localeNumberSample,
      fetchAttributesRequestStatus,
      isUngatedBetaLanguages,
      stagedLanguage,
      stagedLocale
    } = this.props;
    return /*#__PURE__*/_jsx(MultiColumn, {
      flush: true,
      children: /*#__PURE__*/_jsx(MultiColumnGroup, {
        children: /*#__PURE__*/_jsx(MultiColumnItem, {
          children: /*#__PURE__*/_jsx(LocaleEditor, {
            failed: anyRequestsFailed(fetchAttributesRequestStatus),
            loading: !allFinished(fetchAttributesRequestStatus),
            language: stagedLanguage || language,
            locale: stagedLocale || locale,
            localeNumberSample: localeNumberSample,
            handleLocaleChanged: this.handleLocaleChanged,
            isUngatedBetaLanguages: isUngatedBetaLanguages
          })
        })
      })
    });
  }
}
const mapStateToProps = state => {
  return {
    language: getCurrentUserLanguage(state),
    locale: getCurrentUserLocale(state),
    localeNumberSample: getLocaleNumberSample(state),
    fetchAttributesRequestStatus: getFetchAttributesRequestStatus(state),
    isUngatedBetaLanguages: getIsUngatedBetaLanguages(state),
    stagedLocale: state.stagedChanges.get(LOCALE),
    stagedLanguage: state.stagedChanges.get(LANGUAGE)
  };
};
export default connect(mapStateToProps, {
  stageChange,
  clearChange
})(LocaleContainer);